import $ from "cash-dom";

// Reveal a collapsed card by animating its max-height from 0 up to its real height, then clearing
// the inline max-height so the card can reflow naturally (and CSS can un-clip its overflow).
function expandCard(card) {
    // Measure the natural height with transitions off, so padding/margin are already at their
    // final values. Reading scrollHeight while those are mid-transition yields a too-small target
    // and the reveal stops short then snaps.
    card.style.transition = 'none';
    card.classList.remove('show-more-hidden');
    card.style.overflow = 'hidden';
    card.style.maxHeight = 'none';
    var target = card.scrollHeight;

    // Snap back to the collapsed state (still without transitions), then animate to the target.
    card.classList.add('show-more-hidden');
    card.style.maxHeight = '0px';
    void card.offsetHeight;

    card.style.transition = '';
    card.classList.remove('show-more-hidden');
    card.style.maxHeight = target + 'px';

    var onEnd = function (ev) {
        if (ev.propertyName !== 'max-height') {
            return;
        }
        card.style.maxHeight = '';
        card.style.overflow = '';
        card.removeEventListener('transitionend', onEnd);
    };
    card.addEventListener('transitionend', onEnd);
}

// Collapse a revealed card by pinning its current height, then animating max-height down to 0.
function collapseCard(card) {
    card.style.overflow = 'hidden';
    card.style.maxHeight = card.scrollHeight + 'px';

    // Force a reflow so the pinned height is the animation's starting point.
    void card.offsetHeight;
    card.classList.add('show-more-hidden');
    card.style.maxHeight = '0px';
}

$(function () {
    $('.show-hide-vendors').on('click', function (e) {
        e.preventDefault();

        var el = $(e.target).hasClass('show-hide-vendors') ?
            $(e.target) :
            $(e.target).closest('.show-hide-vendors');

        var expanding = el.hasClass('show-more');

        document.querySelectorAll('.ppc-single-vendor.show-more-hideable').forEach(function (card) {
            if (expanding) {
                expandCard(card);
            } else {
                collapseCard(card);
            }
        });

        if (expanding) {
            el.removeClass('show-more').addClass('show-less');
        } else {
            el.removeClass('show-less').addClass('show-more');
        }
    });
});
